import axios from 'axios'

export default {
  getDetails: () => axios.get('/account/details'),
  getTaxInformation: () => axios.get('/account/tax-information'),
  update: (data) => axios.post('/account/update', data),
  changePassword: (data) => axios.post('/account/change-password', data),
}
